import { Figure } from "components/Figure";
import styles from "./Embed.module.css";

export const EmbedWrapper = ({ primary }) => {
  const { caption, embed } = primary;
  return <Embed caption={caption} html={embed.html} />;
};

export const Embed = ({ caption, html }) => (
  <Figure caption={caption}>
    <div
      className={styles.iframeContainer}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  </Figure>
);
